import { render, staticRenderFns } from "./RetailerShortageItemList.vue?vue&type=template&id=5dcf6ca8&"
import script from "./RetailerShortageItemList.vue?vue&type=script&lang=js&"
export * from "./RetailerShortageItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports